<template>
    <BaseCarouselModule v-bind="$props" :shoppableImageModule="ShoppableImageModule" />
</template>

<script>
import { markRaw, defineAsyncComponent } from 'vue';

import carouselModuleProps from '~coreModules/contentful/js/carouselModuleProps';

import BaseCarouselModule from '~coreModules/contentful/components/BaseCarouselModule.vue';

export default {
    name: 'CarouselModule',
    components: {
        BaseCarouselModule,
    },
    mixins: [carouselModuleProps],
    data() {
        return {
            ShoppableImageModule: markRaw(
                defineAsyncComponent(
                    () => import(
                        /* webpackChunkName: "ShoppableImageModule" */
                        '~modules/contentful/components/ShoppableImageModule.vue'),
                ),
            ),
        };
    },
};
</script>
